import React, { useState, useRef } from 'react';

import emailjs from 'emailjs-com'; // Import emailjs-com
import UploadFile from './UploadFile';

const RequestEstimate = () => {
  const form = useRef();
  const [submissionMessage, setSubmissionMessage] = useState(""); // State for submission message

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_inf9o2q",
        "template_1aykwvz",
        form.current,
        "rkLRENvA99w-bn5Bb"
      ) // Replace with your service, template, and user ID
      .then(
        (result) => {
          console.log(result.text);
          setSubmissionMessage("Email sent successfully"); // Update submission message
        },
        (error) => {
          console.log(error.text);
          setSubmissionMessage("Error sending email"); // Update submission message
        }
      );
  };

  return (
    <div className="container contact-container">
      <h1>Request an Estimate</h1>
      <p>Fill out the form below, and we'll get back to you with an estimate for your project.</p>
      <form className="contact-form" ref={form} onSubmit={sendEmail}>
        <div className="mb-3">
          <label htmlFor="name" className="form-label">
            Name:
          </label>
          <input
            type="text"
            className="form-control"
            id="name"
            name="to_name"
          />
        </div>
        <div className="mb-3">
          <label htmlFor="email" className="form-label">
            Email:
          </label>
          <input
            type="email"
            className="form-control"
            id="email"
            name="from_name"
          />
        </div>
        <div className="mb-3">
          <label htmlFor="message" className="form-label">
            Message:
          </label>
          <textarea
            className="form-control"
            id="message"
            name="message"
            rows="4"
          />
          
        </div>
        <button type="submit" value="Send" className="btn btn-primary">
          Submit
        </button>
      </form>
      {submissionMessage && <div className="mt-3">{submissionMessage}</div>}
      <UploadFile />
    </div>
    
  );
};

export default RequestEstimate;





      

